"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require("react-router-dom");

var _semanticUiReact = require("semantic-ui-react");

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dateFns = require("date-fns");

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

require("moment/locale/ca");

var _MilloraDades = require("../../components/MilloraDades/MilloraDades");

var _MilloraDades2 = _interopRequireDefault(_MilloraDades);

var _request = require("../../common/request");

var _request2 = _interopRequireDefault(_request);

var _constants = require("../../utils/constants");

var CONSTANTS = _interopRequireWildcard(_constants);

var _Gestor = require("./Gestor.css");

var _Gestor2 = _interopRequireDefault(_Gestor);

var _FixedMenuLayout = require("../../layouts/FixedMenuLayout");

var _FixedMenuLayout2 = _interopRequireDefault(_FixedMenuLayout);

var _universalCookie = require("universal-cookie");

var _universalCookie2 = _interopRequireDefault(_universalCookie);

var _share = require("../../utils/share");

var _share2 = _interopRequireDefault(_share);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //      


var cookies = new _universalCookie2.default();

var Gestor = function (_React$Component) {
	_inherits(Gestor, _React$Component);

	function Gestor(props) {
		_classCallCheck(this, Gestor);

		var _this = _possibleConstructorReturn(this, (Gestor.__proto__ || Object.getPrototypeOf(Gestor)).call(this, props));

		_this.showMillorar = function (estat) {
			return _this.setState({ millorarDades: true });
		};

		_this.tornaGestor = function (estat) {
			return _this.setState({ millorarDades: false });
		};

		_this.closeModal = function () {
			return _this.setState({ open: false, deleteindex: -1 });
		};

		_this.showModal = function (index, currentAction, titleMsg, bodyMsg) {
			return _this.setState({
				open: true,
				deleteindex: index,
				currentAction: currentAction,
				titleMsg: titleMsg,
				bodyMsg: bodyMsg
			});
		};

		_this.checkTags = function (tags) {
			return tags && tags.length ? tags.join(",") : " ";
		};

		_this.checkDinamic = function (tipus, dynamic) {
			return tipus === "latest" || dynamic ? tipus + " / din\xE0mic" : tipus + " / no din\xE0mic";
		};

		_this.isPublicat = function (title) {
			return title !== CONSTANTS.DEFAULT_TITOL_GENERIC;
		};

		_this.handleSort = function (clickedColumn) {
			return function () {
				var _this$state = _this.state,
				    sortedColumn = _this$state.sortedColumn,
				    sortedDirection = _this$state.sortedDirection,
				    loadedData = _this$state.loadedData;


				if (sortedColumn !== clickedColumn) {

					loadedData = loadedData.sort(function (a, b) {
						return a[clickedColumn].toLowerCase().trim().localeCompare(b[clickedColumn].toLowerCase().trim());
					});
					_this.setState({
						sortedColumn: clickedColumn,
						loadedData: loadedData,
						sortedDirection: "ascending"
					});
				} else {

					loadedData = loadedData.reverse();
					_this.setState({
						loadedData: loadedData,
						sortedDirection: sortedDirection === "ascending" ? "descending" : "ascending"
					});
				}
			};
		};

		_this.state = {
			loadedData: null,
			loading: true,
			showError: false,
			errorMsg: "",
			currentAction: null,
			titleMsg: "",
			bodyMsg: "",
			open: false,
			filtreCerca: "",
			header: null,
			organization: null,
			millorarDades: false,
			timestampEstacions: "Carregant info...",
			timestampIndexos: "Carregant info..."
		};
		return _this;
	}

	_createClass(Gestor, [{
		key: "componentDidMount",
		value: function () {
			var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
				var logged;
				return regeneratorRuntime.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return this.userLogged();

							case 2:
								logged = _context.sent;


								this.setState({
									header: logged ? "logged" : "no_logged"
								});

								if (logged) {
									this.loadTimestamps();
									this.loadApplications();
								}

							case 5:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, this);
			}));

			function componentDidMount() {
				return _ref.apply(this, arguments);
			}

			return componentDidMount;
		}()

		// eslint-disable-next-line camelcase

	}, {
		key: "UNSAFE_componentWillMount",
		value: function UNSAFE_componentWillMount() {
			/*
   if (this.props.location && this.props.location.state) {
   	const {isAuth, header } = this.props.location.state;
   	//console.info("add cookie", this.props.location.header);
   	cookies.set("myToken", this.props.location.header, { path: "/" });
   	this.setState({ isAuth: isAuth, header: header });
     }
   */
		}
	}, {
		key: "userLogged",
		value: function () {
			var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
				var _organization, _header;

				return regeneratorRuntime.wrap(function _callee2$(_context2) {
					while (1) {
						switch (_context2.prev = _context2.next) {
							case 0:

								//console.info("cookie", cookies.get("myToken"));
								_organization = this.props.header && this.props.header.organization ? this.props.header.organization : cookies.get("myOrganization");
								_context2.next = 3;
								return _share2.default.getUserLogged(cookies.get("myToken"));

							case 3:
								_header = _context2.sent;


								//console.info("headerRRRR", _header);
								this.setState({
									header: _header,
									organization: _organization
								});

								return _context2.abrupt("return", _header);

							case 6:
							case "end":
								return _context2.stop();
						}
					}
				}, _callee2, this);
			}));

			function userLogged() {
				return _ref2.apply(this, arguments);
			}

			return userLogged;
		}()
	}, {
		key: "loadTimestamps",
		value: function () {
			var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
				var timestampsEstacions, timestampIndexos;
				return regeneratorRuntime.wrap(function _callee3$(_context3) {
					while (1) {
						switch (_context3.prev = _context3.next) {
							case 0:
								_context3.next = 2;
								return this.getLastUpdateTimestamp("estacions");

							case 2:
								timestampsEstacions = _context3.sent;
								_context3.next = 5;
								return this.getLastUpdateTimestamp("indexos");

							case 5:
								timestampIndexos = _context3.sent;


								this.setState({
									open: false,
									currentAction: null,
									timestampEstacions: timestampsEstacions,
									timestampIndexos: timestampIndexos
								});

							case 7:
							case "end":
								return _context3.stop();
						}
					}
				}, _callee3, this);
			}));

			function loadTimestamps() {
				return _ref3.apply(this, arguments);
			}

			return loadTimestamps;
		}()
	}, {
		key: "loadApplications",
		value: function loadApplications() {
			var _this2 = this;

			var URL_GESTOR = CONSTANTS.URL_GET_CONFIG + "/" + this.state.organization;

			_request2.default.get(URL_GESTOR).then(function (data) {

				_this2.setState({
					loading: false,
					loadedData: data, //.filter(visor => this.isPublicat(visor.title)),
					deleteindex: -1,
					open: false
				});

				//this.removeNoPublicats(data.filter(visor => !this.isPublicat(visor.title)));
			}).catch(function (err) {

				_this2.setState({ loading: false, showError: true, errorMsg: err });
			});
		}
	}, {
		key: "getLastUpdateTimestamp",
		value: function getLastUpdateTimestamp(tipusFile) {

			return new Promise(function (resolve) {

				_request2.default.get(CONSTANTS.URL_SERVER + "/timestamp." + tipusFile + ".txt").then(function (timestamp) {
					return resolve(timestamp);
				}).catch(function () {
					return resolve("");
				});
			});
		}

		/*removeNoPublicats(nopublicats) {
  		if (nopublicats.length > 0) {
  		//TODO Request clean no publicats
  	}
  	} */

	}, {
		key: "doDeleteVisor",
		value: function doDeleteVisor(deleteindex) {
			var _this3 = this;

			var loadedData = this.state.loadedData;


			if (loadedData[deleteindex].databasename && loadedData[deleteindex].databasename.indexOf("update_") !== -1) {
				_request2.default.delete(CONSTANTS.URL_DELETE_APPS + "/" + loadedData[deleteindex].databasename).then(function () {
					//
				}).catch(function (err) {
					_this3.setState({ open: false, deleteindex: -1, showError: true, errorMsg: err, loading: false });
				});
			}

			_request2.default.delete(CONSTANTS.URL_DELETE_APPS + "/" + loadedData[deleteindex].apps.visor).then(function () {

				_request2.default.delete(CONSTANTS.URL_DELETE_APPS + "/" + loadedData[deleteindex].geojson).then(function () {

					var newLoadedData = [].concat(_toConsumableArray(loadedData));
					newLoadedData.splice(deleteindex, 1);
					_this3.setState({ open: false, deleteindex: -1, loading: false, loadedData: newLoadedData });
				}).catch(function (err) {
					_this3.setState({ open: false, deleteindex: -1, showError: true, errorMsg: err, loading: false });
				});
			}).catch(function (err) {
				_this3.setState({ open: false, deleteindex: -1, showError: true, errorMsg: err, loading: false });
			});
		}
	}, {
		key: "doUpdateDBBackgroundProcess",
		value: function doUpdateDBBackgroundProcess(url) {
			var _this4 = this;

			_request2.default.get(url).then(function () {
				_this4.loadTimestamps();
			}).catch(function (err) {
				_this4.setState({ open: false, currentAction: null, showError: true, errorMsg: err, loading: false });
			});
		}
	}, {
		key: "generateAction",
		value: function generateAction() {
			var _state = this.state,
			    deleteindex = _state.deleteindex,
			    currentAction = _state.currentAction;


			if (currentAction === CONSTANTS.DO_DELETE && deleteindex !== -1) {
				this.setState({ loading: true });
				this.doDeleteVisor(deleteindex);
			} else if (currentAction === CONSTANTS.DO_UPDATEESTACIONS) {
				this.doUpdateDBBackgroundProcess(CONSTANTS.URL_UPDATESTATIONS);
			} else if (currentAction === CONSTANTS.DO_UPDATEINDEXOS) {
				this.doUpdateDBBackgroundProcess(CONSTANTS.URL_RECREATE_INDEX);
			}
		}
	}, {
		key: "onSelectVisors",
		value: function onSelectVisors(valor) {

			this.setState({ filtreCerca: valor });
		}
	}, {
		key: "renderIsNoPublicat",
		value: function renderIsNoPublicat() {

			return _react2.default.createElement(
				_semanticUiReact.Message,
				{ size: "small", compact: true, warning: true },
				_react2.default.createElement(_semanticUiReact.Icon, { name: "warning" }),
				"Visor no publicat"
			);
		}
	}, {
		key: "renderApplications",
		value: function renderApplications() {
			var _this5 = this;

			var _state2 = this.state,
			    loadedData = _state2.loadedData,
			    filtreCerca = _state2.filtreCerca;


			var newDD = loadedData.filter(function (station) {
				return station.title.toLowerCase().indexOf(filtreCerca.toLowerCase()) != -1 || station.stats.toLowerCase().indexOf(filtreCerca.toLowerCase()) != -1 || station.tags.join(",").toLowerCase().indexOf(filtreCerca.toLowerCase()) != -1;
			});

			return newDD.map(function (station, i) {
				return _react2.default.createElement(
					_semanticUiReact.Table.Row,
					{ key: i },
					_react2.default.createElement(
						_semanticUiReact.Table.Cell,
						null,
						_react2.default.createElement(
							"a",
							{ title: "Anar al visor", target: "_blank", rel: "noopener noreferrer", href: CONSTANTS.URL_APP + "/visor/" + station.organization + "/" + station.apps.visor },
							_react2.default.createElement(
								"span",
								{ className: _this5.isPublicat(station.title) ? _Gestor2.default.titlePublicat : _Gestor2.default.titleNoPublicat },
								station.title
							)
						)
					),
					_react2.default.createElement(
						_semanticUiReact.Table.Cell,
						{ textAlign: "center" },
						_react2.default.createElement(
							_reactRouterDom.Link,
							{ title: "Editor", to: "/editor/" + station.organization + "/" + station.apps.editor },
							_react2.default.createElement(_semanticUiReact.Icon, { circular: true, bordered: true, color: "teal", name: "edit", content: "Editor" })
						),
						_react2.default.createElement(
							"a",
							{ title: "Visor", target: "_blank", rel: "noopener noreferrer", href: CONSTANTS.URL_APP + "/visor/" + station.organization + "/" + station.apps.visor },
							_react2.default.createElement(_semanticUiReact.Icon, { circular: true, color: "teal", name: "eye", content: "Visor" })
						),
						_react2.default.createElement(
							"a",
							{ title: "Fitxer GeoJson", target: "_blank", rel: "noopener noreferrer", href: CONSTANTS.URL_SERVER + "/" + station.geojson },
							_react2.default.createElement(_semanticUiReact.Icon, { circular: true, color: "teal", name: "file", content: "Fitxer" })
						),
						_react2.default.createElement(_semanticUiReact.Icon, {
							circular: true, link: true,
							name: "trash",
							color: "red", content: "Esborrar",
							onClick: function onClick() {
								return _this5.showModal(i, CONSTANTS.DO_DELETE, "Esborrar mapa", "Vols esborrar aquesta visualització?");
							} })
					),
					_react2.default.createElement(
						_semanticUiReact.Table.Cell,
						{ textAlign: "center" },
						" " + (0, _moment2.default)(station.stats).format("YYYY-MM-DD HH:mm") + "h"
					),
					_react2.default.createElement(
						_semanticUiReact.Table.Cell,
						{ textAlign: "center" },
						_this5.checkTags(station.tags)
					),
					_react2.default.createElement(
						_semanticUiReact.Table.Cell,
						{ textAlign: "center" },
						_this5.checkDinamic(station.tipus, station.dynamic)
					),
					_react2.default.createElement(
						_semanticUiReact.Table.Cell,
						{ textAlign: "center" },
						station.databasename
					)
				);
			});
		}
	}, {
		key: "renderApplicationsOld",
		value: function renderApplicationsOld() {
			var _this6 = this;

			var loadedData = this.state.loadedData;


			console.info(loadedData);

			return loadedData.map(function (station, i) {
				return _react2.default.createElement(
					_semanticUiReact.Card,
					{ fluid: true, color: "teal", key: i },
					_react2.default.createElement(
						_semanticUiReact.Card.Content,
						null,
						_react2.default.createElement(
							_semanticUiReact.Card.Header,
							null,
							_react2.default.createElement(
								"div",
								{ className: _Gestor2.default.containerHeader },
								_react2.default.createElement(
									"span",
									{ className: _this6.isPublicat(station.title) ? "" : _Gestor2.default.titleNoPublicat },
									station.title
								),
								_react2.default.createElement(_semanticUiReact.Button, {
									size: "mini", basic: true,
									icon: "trash", labelPosition: "right",
									className: _Gestor2.default.btdelete,
									color: "red", content: "Esborrar",
									onClick: function onClick() {
										return _this6.showModal(i, CONSTANTS.DO_DELETE, "Esborrar mapa", "Vols esborrar aquesta visualització?");
									} })
							)
						)
					),
					_react2.default.createElement(
						_semanticUiReact.Card.Content,
						null,
						!_this6.isPublicat(station.title) && _this6.renderIsNoPublicat(),
						_react2.default.createElement(
							_semanticUiReact.Card.Meta,
							null,
							"Tipus: " + _this6.checkDinamic(station.tipus, station.dynamic),
							" "
						),
						_react2.default.createElement(
							_semanticUiReact.Card.Meta,
							null,
							"Data creaci\xF3: " + (0, _moment2.default)(station.stats).format("YYYY-MM-DD HH:mm") + "h",
							" "
						),
						_react2.default.createElement(_semanticUiReact.Divider, null),
						_react2.default.createElement(
							_semanticUiReact.Card.Description,
							null,
							_react2.default.createElement(
								_semanticUiReact.Header,
								{ size: "small", color: "teal" },
								"Obrir:"
							),
							_react2.default.createElement(
								_semanticUiReact.Button.Group,
								null,
								_react2.default.createElement(
									_reactRouterDom.Link,
									{ to: "/editor/" + station.apps.editor },
									_react2.default.createElement(_semanticUiReact.Button, { color: "teal", icon: "edit", content: "Editor" })
								),
								_react2.default.createElement(_semanticUiReact.Button.Or, { text: "o" }),
								_react2.default.createElement(
									"a",
									{ target: "_blank", rel: "noopener noreferrer", href: CONSTANTS.URL_APP + "/visor/" + station.apps.visor },
									_react2.default.createElement(_semanticUiReact.Button, { color: "teal", icon: "map outline", content: "Visor" })
								),
								_react2.default.createElement(_semanticUiReact.Button.Or, { text: "o" }),
								_react2.default.createElement(
									"a",
									{ target: "_blank", rel: "noopener noreferrer", href: CONSTANTS.URL_SERVER + "/" + station.geojson },
									_react2.default.createElement(_semanticUiReact.Button, { color: "teal", icon: "file", content: "Fitxer Geojson" })
								)
							)
						)
					)
				);
			});
		}
	}, {
		key: "renderApplicationsList",
		value: function renderApplicationsList() {
			var _this7 = this;

			var _state3 = this.state,
			    column = _state3.column,
			    sortedDirection = _state3.sortedDirection;

			var style = { width: "99%" };
			var columnStateStyle = { width: "300px" };
			var columnStateStyle2 = { width: "200px" };
			var color = "teal";

			if (this.state.loading) {
				return _react2.default.createElement(
					_semanticUiReact.Loader,
					{ size: "huge", active: true },
					"Carregant dades..."
				);
			} else if (this.state.showError) {

				return _react2.default.createElement(
					_semanticUiReact.Message,
					{ negative: true },
					_react2.default.createElement(
						_semanticUiReact.Message.Header,
						null,
						"Error"
					),
					_react2.default.createElement(
						"p",
						null,
						"Ha ocorregut un error: ",
						this.state.errorMsg
					)
				);
			}

			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_semanticUiReact.Input, { size: "large", icon: "search", onChange: function onChange(e, data) {
						return _this7.onSelectVisors(data.value);
					}, placeholder: "Cercar..." }),
				_react2.default.createElement("hr", null),
				_react2.default.createElement(
					"div",
					{ className: _Gestor2.default.myTable },
					_react2.default.createElement(
						_semanticUiReact.Table,
						{ style: style, color: color, key: color, columns: 6, fixed: true, sortable: true, selectable: true, verticalAlign: "middle" },
						_react2.default.createElement(
							_semanticUiReact.Table.Header,
							{ className: _Gestor2.default.myTableHeader, color: color, key: color },
							_react2.default.createElement(
								_semanticUiReact.Table.Row,
								null,
								_react2.default.createElement(
									_semanticUiReact.Table.HeaderCell,
									{ style: columnStateStyle, sorted: column === "titol" ? sortedDirection : null, onClick: this.handleSort("data") },
									"Visors"
								),
								_react2.default.createElement(
									_semanticUiReact.Table.HeaderCell,
									{ textAlign: "center", style: columnStateStyle2 },
									"Accions"
								),
								_react2.default.createElement(
									_semanticUiReact.Table.HeaderCell,
									{ textAlign: "center", sorted: column === "data" ? sortedDirection : null, onClick: this.handleSort("data") },
									"Data"
								),
								_react2.default.createElement(
									_semanticUiReact.Table.HeaderCell,
									{ textAlign: "center", sorted: column === "tags" ? sortedDirection : null, onClick: this.handleSort("tags") },
									"Tags"
								),
								_react2.default.createElement(
									_semanticUiReact.Table.HeaderCell,
									{ textAlign: "center", sorted: column === "tipus" ? sortedDirection : null, onClick: this.handleSort("tipus") },
									"Tipus"
								),
								_react2.default.createElement(
									_semanticUiReact.Table.HeaderCell,
									{ textAlign: "center", sorted: column === "origen" ? sortedDirection : null, onClick: this.handleSort("origen") },
									"Origen"
								)
							)
						),
						_react2.default.createElement(
							_semanticUiReact.Table.Body,
							null,
							this.renderApplications()
						)
					)
				)
			);
		}
	}, {
		key: "renderApplicationsListOld",
		value: function renderApplicationsListOld() {

			if (this.state.loading) {
				return _react2.default.createElement(
					_semanticUiReact.Loader,
					{ size: "huge", active: true },
					"Carregant dades..."
				);
			} else if (this.state.showError) {

				return _react2.default.createElement(
					_semanticUiReact.Message,
					{ negative: true },
					_react2.default.createElement(
						_semanticUiReact.Message.Header,
						null,
						"Error"
					),
					_react2.default.createElement(
						"p",
						null,
						"Ha ocorregut un error: ",
						this.state.errorMsg
					)
				);
			}

			return _react2.default.createElement(
				_semanticUiReact.Card.Group,
				null,
				this.renderApplications()
			);
		}
	}, {
		key: "renderConfigButton",
		value: function renderConfigButton() {
			var _this8 = this;

			var trigger = _react2.default.createElement(
				"span",
				null,
				_react2.default.createElement(_semanticUiReact.Icon, { size: "large", name: "cogs" })
			);

			var _state4 = this.state,
			    timestampEstacions = _state4.timestampEstacions,
			    timestampIndexos = _state4.timestampIndexos;


			return _react2.default.createElement(
				_semanticUiReact.Menu.Item,
				{ position: "right" },
				_react2.default.createElement(
					_semanticUiReact.Dropdown,
					{ trigger: trigger, pointing: "right", icon: null },
					_react2.default.createElement(
						_semanticUiReact.Dropdown.Menu,
						null,
						_react2.default.createElement(_semanticUiReact.Dropdown.Item, { icon: "refresh", text: "Actualitzar taula estacions", description: timestampEstacions, onClick: function onClick() {
								return _this8.showModal(-1, CONSTANTS.DO_UPDATEESTACIONS, "Actualitzar", "Aquest operació pot tardar uns minuts i es realitzarà en segon pla. L'operació sempre s'aplica sobre le dades de l'any en curs");
							} }),
						_react2.default.createElement(_semanticUiReact.Dropdown.Divider, null),
						_react2.default.createElement(_semanticUiReact.Dropdown.Item, { icon: "refresh", text: "Regenerar \xEDndexs", description: timestampIndexos, onClick: function onClick() {
								return _this8.showModal(-1, CONSTANTS.DO_UPDATEINDEXOS, "Regenerar", "Aquest operació pot tardar uns minuts i es realitzarà en segon pla.");
							} }),
						_react2.default.createElement(_semanticUiReact.Dropdown.Divider, null),
						_react2.default.createElement(_semanticUiReact.Dropdown.Item, { icon: "refresh", onClick: function onClick() {
								return _this8.showMillorar(true);
							}, text: "Actualitzar dades meteorol\xF2giques" })
					)
				)
			);
		}
	}, {
		key: "render",
		value: function render() {
			var _this9 = this;

			var _state5 = this.state,
			    open = _state5.open,
			    titleMsg = _state5.titleMsg,
			    bodyMsg = _state5.bodyMsg,
			    millorarDades = _state5.millorarDades;

			// eslint-disable-next-line react/prop-types
			//console.info("header", this.props.location.header);

			//console.info("state.header", this.state.header);
			// eslint-disable-next-line react/prop-types
			//if (this.props.location.state && this.props.location.state.header) {

			if (this.state.header === "logged" && this.state.millorarDades === false) {
				return _react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(_FixedMenuLayout2.default, { organization: this.state.organization, renderButtons: this.renderConfigButton() }),
					_react2.default.createElement(
						_semanticUiReact.Container,
						{ fluid: true, className: _Gestor2.default.containerStyle, textAlign: "justified" },
						this.renderApplicationsList()
					),
					_react2.default.createElement(
						_semanticUiReact.Modal,
						{ size: "mini", open: open, onClose: this.closeModal },
						_react2.default.createElement(
							_semanticUiReact.Modal.Header,
							null,
							titleMsg
						),
						_react2.default.createElement(
							_semanticUiReact.Modal.Content,
							null,
							_react2.default.createElement(
								"p",
								null,
								bodyMsg
							)
						),
						_react2.default.createElement(
							_semanticUiReact.Modal.Actions,
							null,
							_react2.default.createElement(
								_semanticUiReact.Button,
								{ onClick: this.closeModal, negative: true },
								"No"
							),
							_react2.default.createElement(_semanticUiReact.Button, { onClick: function onClick() {
									return _this9.generateAction();
								}, positive: true, icon: "checkmark", labelPosition: "right", content: "Si" })
						)
					)
				);
			} else if (this.state.header === "logged" && this.state.millorarDades === true) {

				return _react2.default.createElement(
					"div",
					null,
					_react2.default.createElement(_FixedMenuLayout2.default, { organization: this.state.organization, renderButtons: this.renderConfigButton() }),
					_react2.default.createElement(
						_semanticUiReact.Container,
						{ fluid: true, className: _Gestor2.default.containerStyle, textAlign: "justified" },
						_react2.default.createElement(_MilloraDades2.default, {
							tornaGestor: this.tornaGestor
						})
					)
				);
			} else if (this.state.header === "no_logged") {

				return _react2.default.createElement(_reactRouterDom.Redirect, { to: { pathname: "/login", origin: "gestor" } });
			} else {

				//console.log("GGGGGGGGGG");
				return _react2.default.createElement(
					_semanticUiReact.Dimmer,
					{ active: true, page: true },
					_react2.default.createElement(
						_semanticUiReact.Header,
						{ as: "h2", icon: true, inverted: true },
						_react2.default.createElement(_semanticUiReact.Icon, { loading: true, name: "rain" }),
						"Autenticant...",
						_react2.default.createElement(
							_semanticUiReact.Header.Subheader,
							null,
							"Plou i fa sol ...."
						)
					)
				);
			}
		}
	}]);

	return Gestor;
}(_react2.default.Component);

exports.default = Gestor;


Gestor.propTypes = {
	params: _propTypes2.default.object,
	header: _propTypes2.default.object
};
